exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ed-recurrence-grid[data-v-4922ed0d] {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\n  gap: 8px;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: start;\n}\n.ed-recurrence[data-v-4922ed0d] {\n  padding: 8px 12px;\n  border: 1px solid var(--ced-border, #e3e5ec);\n  border-radius: 8px;\n}\n.ed-recurrence .v-input--selection-controls[data-v-4922ed0d] {\n  margin-top: 0;\n  padding-top: 0;\n}\n.ed-recurrence--on[data-v-4922ed0d] {\n  border-color: var(--ced-primary, #02acb4);\n  background: var(--ced-primary-soft, #e6f7f8);\n}\n", ""]);

// exports
